/**
 * 工具类方法
 */

/* 获取相关url配置信息 */
export const getUrlConfig = () => {
  let apiDomain = ""; // 接口API域名
  const { hostname } = window.location;
  switch (hostname) {
    // 测试
    case "dev-qgxf.cn": {
      apiDomain = import.meta.env.VITE_APP_BASE_API;
      break;
    }
    // 生产
    case "prod-qgxf.cn": {
      apiDomain = import.meta.env.VITE_APP_BASE_API;
      break;
    }
    // 开发
    case "localhost":
    default: {
      apiDomain = import.meta.env.VITE_APP_BASE_API;
      break;
    }
  }
  return {
    apiDomain,
  };
};

// fn => 回调方法，t 定时毫秒
export const mySetInterval = (fn, t = 0) => {
  if (typeof fn !== "function") {
    return null;
  }
  let timer = null;
  const interval = () => {
    fn();
    timer = setTimeout(interval, t);
  };
  interval();
  return {
    clear: () => {
      clearTimeout(timer);
    },
  };
};

/**
 * 动态加载JS/CSS资源
 */
export const loadSrc = (url, domId, type) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error("请设置加载资源的url"));
      return false;
    }
    if (!domId) {
      reject(new Error("请设置加载资源的dom Id"));
      return false;
    }
    if (document.getElementById(domId)) {
      resolve();
    } else {
      if (type === "css") {
        const cssLink = document.createElement("link");
        cssLink.id = domId;
        cssLink.type = "text/css";
        cssLink.rel = "stylesheet";
        cssLink.href = url;
        cssLink.onload = () => {
          resolve();
        };
        document.head.appendChild(cssLink);
      } else {
        const jsScript = document.createElement("script");
        jsScript.id = domId;
        jsScript.type = "text/javascript";
        jsScript.onload = () => {
          resolve();
        };
        jsScript.src = url;
        document.body.appendChild(jsScript);
      }
    }
  });
};

/**
 * 时间日期转换
 * @param date 当前时间，new Date() 格式
 * @param format 需要转换的时间格式字符串
 * @description format 字符串随意，如 `YYYY-mm、YYYY-mm-dd`
 * @description format 季度："YYYY-mm-dd HH:MM:SS QQQQ"
 * @description format 星期："YYYY-mm-dd HH:MM:SS WWW"
 * @description format 几周："YYYY-mm-dd HH:MM:SS ZZZ"
 * @description format 季度 + 星期 + 几周："YYYY-mm-dd HH:MM:SS WWW QQQQ ZZZ"
 * @returns 返回拼接后的时间字符串
 */
export function formatDate(date, format) {
  const we = date.getDay(); // 星期
  const z = getWeek(date); // 周
  const qut = Math.floor((date.getMonth() + 3) / 3).toString(); // 季度
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月(月份从0开始，要+1)
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    "q+": qut, // 季度
  };
  // 中文数字 (星期)
  const week = {
    0: "日",
    1: "一",
    2: "二",
    3: "三",
    4: "四",
    5: "五",
    6: "六",
  };
  // 中文数字（季度）
  const quarter = {
    1: "一",
    2: "二",
    3: "三",
    4: "四",
  };
  if (/(W+)/.test(format))
    format = format.replace(
      RegExp.$1,
      RegExp.$1.length > 1
        ? RegExp.$1.length > 2
          ? `星期${week[we]}`
          : `周${week[we]}`
        : week[we]
    );
  if (/(Q+)/.test(format))
    format = format.replace(
      RegExp.$1,
      RegExp.$1.length == 4 ? `第${quarter[qut]}季度` : quarter[qut]
    );
  if (/(Z+)/.test(format))
    format = format.replace(
      RegExp.$1,
      RegExp.$1.length == 3 ? `第${z}周` : `${z}`
    );
  for (const k in opt) {
    const r = new RegExp(`(${k})`).exec(format);
    // 若输入的长度不为1，则前面补零
    if (r)
      format = format.replace(
        r[1],
        RegExp.$1.length == 1 ? opt[k] : opt[k].padStart(RegExp.$1.length, "0")
      );
  }
  return format;
}

/**
 * 获取当前日期是第几周
 * @param dateTime 当前传入的日期值
 * @returns 返回第几周数字值
 */
export function getWeek(dateTime) {
  const temptTime = new Date(dateTime.getTime());
  // 周几
  const weekday = temptTime.getDay() || 7;
  // 周1+5天=周六
  temptTime.setDate(temptTime.getDate() - weekday + 1 + 5);
  let firstDay = new Date(temptTime.getFullYear(), 0, 1);
  const dayOfWeek = firstDay.getDay();
  let spendDay = 1;
  if (dayOfWeek != 0) spendDay = 7 - dayOfWeek + 1;
  firstDay = new Date(temptTime.getFullYear(), 0, 1 + spendDay);
  const d = Math.ceil((temptTime.valueOf() - firstDay.valueOf()) / 86400000);
  const result = Math.ceil(d / 7);
  return result;
}

/**
 * base64 转 Blob
 */
export const base64ToBlob = (url) => {
  let arr = url.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

//将秒转化成时间;
export const changeToTime = (time) => {
  let hour = 0;
  let min = 0;
  let second = time;
  if (time >= 60) {
    min = parseInt(time / 60);
    second = time % 60;
    if (min >= 60) {
      hour = parseInt(min / 60);
      min = min % 60;
    }
  }

  return `${fillNum(hour)}:${fillNum(min)}:${fillNum(second)}`;
};

//将时间转化成秒
export const timeChange = (time) => {
  if (!time) {
    return 0;
  }
  let timeArr = time.split(":");
  let timeLeng = timeArr.length;
  switch (timeLeng) {
    case 3:
      return (
        parseInt(timeArr[0] * 3600) +
        parseInt(timeArr[1] * 60) +
        parseInt(timeArr[2])
      );
    case 2:
      return parseInt(timeArr[0] * 60) + parseInt(timeArr[1]);
    case 1:
      return parseInt(timeArr[0]);
  }
};

export function fillNum(number) {
  let num = number >= 10 ? "" + number : "0" + number;
  return num;
}

// 屏蔽浏览器默认行为
export function stopBrowserAction(a) {
  const ona = "on" + a;
  document[ona] = function (e) {
    e.preventDefault();
    return false;
  };
}

// 解除屏蔽浏览器默认行为
export function restartBrowserAction(a) {
  const ona = "on" + a;
  if (window.addEventListener) {
    window.addEventListener(
      a,
      function (e) {
        for (var n = e.originalTarget; n; n = n.parentNode) {
          n[ona] = null;
        }
      },
      true
    );
  }
  window[ona] = null;
  document[ona] = null;
  if (document.body) {
    document.body[ona] = null;
  }
}



export const calcTimeProgress = (time1, time2) => {
  // 将时间字符串转换为秒数
  const parseTime = (time) => {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  };

  const seconds1 = parseTime(time1);
  const seconds2 = parseTime(time2);

  // 计算 time2 占 time1 的百分比
  const percentage = Math.floor((seconds2 / seconds1) * 100);

  return percentage;
}